import { render, staticRenderFns } from "./c2LowFrequencyRegionPage.vue?vue&type=template&id=11650dda&scoped=true&"
import script from "./c2LowFrequencyRegionPage.vue?vue&type=script&lang=js&"
export * from "./c2LowFrequencyRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./c2LowFrequencyRegionPage.vue?vue&type=style&index=0&id=11650dda&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11650dda",
  null
  
)

export default component.exports